/**
 * Hover interactions handler
 */
class HoverBox {

	/**
	 * Initialize hover box
	 * @param {HTMLElement} box
	 */
	constructor( box ) {

		this.box = box;
		this.content = box.querySelector( '.b-hover-box__content' );
		if ( !this.content ) {

			return;

		}

		this.topClassTimeout = null;
		this.originalBoxHeight = null;
		this.isDesktopQuery = window.matchMedia( '(min-width: 1024px)' );

		this.init();

	}

	/**
	 * Init events and listeners
	 * @return {void}
	 */
	init() {

		this.bindEvents();
		this.isDesktopQuery.addEventListener( 'change', () => this.reset() );

	}

	/**
	 * Bind event listeners
	 * @return {void}
	 */
	bindEvents() {

		this.box.addEventListener( 'mouseenter', () => {

			if ( this.isDesktop() ) {

				this.openDesktop();

			}

		} );

		this.box.addEventListener( 'mouseleave', () => {

			if ( this.isDesktop() ) {

				this.closeDesktop();

			}

		} );

		this.box.addEventListener( 'click', () => {

			if ( !this.isDesktop() ) {

				this.toggleMobile();

			}

		} );

	}

	/**
	 * Check if desktop breakpoint
	 * @return {boolean}
	 */
	isDesktop() {

		return this.isDesktopQuery.matches;

	}

	/**
	 * Open hover box on desktop
	 * @return {void}
	 */
	openDesktop() {

		if ( this.topClassTimeout ) {

			clearTimeout( this.topClassTimeout );
			this.topClassTimeout = null;

		}

		this.originalBoxHeight = this.box.offsetHeight;
		this.box.style.height = `${this.originalBoxHeight  }px`;
		this.content.style.height = `${this.content.scrollHeight  }px`;

		this.box.classList.add( 'is-open', 'is-top' );
		this.updateLastClasses();

	}

	/**
	 * Close hover box on desktop
	 * @return {void}
	 */
	closeDesktop() {

		this.content.style.height = '0';
		this.box.classList.remove( 'is-open' );

		this.topClassTimeout = setTimeout( () => {

			this.box.classList.remove( 'is-top' );
			this.box.style.height = '';
			this.topClassTimeout = null;

		}, 250 );

	}

	/**
	 * Toggle mobile open/close
	 * @return {void}
	 */
	toggleMobile() {

		if ( this.box.classList.contains( 'is-open' ) ) {

			this.content.style.height = '0';
			this.box.classList.remove( 'is-open', 'is-top' );

		} else {

			this.content.style.height = `${this.content.scrollHeight  }px`;
			this.box.classList.add( 'is-open', 'is-top' );
			this.updateLastClasses();

		}

	}

	/**
	 * Update last/second-last classes
	 * @return {void}
	 */
	updateLastClasses() {

		const siblings = Array.from( this.box.parentElement.querySelectorAll( '.b-hover-box' ) );
		siblings.forEach( el => el.classList.remove( 'is-last', 'is-second-last' ) );

		const last = siblings.at( -1 );
		const secondLast = siblings.at( -2 );
		if ( secondLast ) {

			secondLast.classList.add( 'is-second-last' );

		}
		if ( last ) {

			last.classList.add( 'is-last' );

		}

	}

	/**
	 * Reset all classes and styles
	 * @return {void}
	 */
	reset() {

		this.box.classList.remove( 'is-open', 'is-top', 'is-last', 'is-second-last' );
		this.box.style.height = '';
		this.content.style.height = '';
		if ( this.topClassTimeout ) {

			clearTimeout( this.topClassTimeout );
			this.topClassTimeout = null;

		}

	}

}

document.querySelectorAll( '.b-hover-boxes .b-hover-box.b-hover-box--type-1' ).forEach( box => {

	new HoverBox( box );

} );

